<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:new="newHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';

import PayItemTypeForm from "../../../components/payroll/payitemtype/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": PayItemTypeForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setuppayitmetype.editpayitemtype'),
      pageTitleValue: "",
      formData: [],
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadPayItemTypeHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/payitemtype/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          //  if (res.data.rec[0].payitemcatid) {
          //      vm.formData.payitemcatid = res.data.rec[0].payitemcatid;
          //  }

          // convert Y/N to boolean
          if (res.data.rec[0].afnetpay == "Y") {
            vm.formData.afnetpay = true;
          } else {
            vm.formData.afnetpay = false;
          }

          if (res.data.rec[0].afgrosspay == "Y") {
            vm.formData.afgrosspay = true;
          } else {
            vm.formData.afgrosspay = false;
          }

          if (res.data.rec[0].isvendor == "Y") {
            vm.formData.isvendor = true;
          } else {
            vm.formData.isvendor = false;
          }

          vm.pageTitleValue = res.data.rec[0].payitemtypedesc;
          vm.formData.userid = this.$store.getters.userId;

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      // change boolean to int
      if (this.formData.afnetpay == true) {
        this.formData.afnetpay = 1;
      } else {
        this.formData.afnetpay = 0;
      }

      if (this.formData.afgrosspay == true) {
        this.formData.afgrosspay = 1;
      } else {
        this.formData.afgrosspay = 0;
      }

      if (this.formData.isvendor == true) {
        this.formData.isvendor = 1;
      } else {
        this.formData.isvendor = 0;
      }

      this.$store.dispatch('put', {url: "/payitemtype/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payitemtypelist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/payitemtype/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payitemtypelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    newHandler() {
      this.$router.push({ name: "payitemtypenew" });
    },

    cancelHandler() {
      this.$router.push({ name: "payitemtypelist" });
    },
  },

  async mounted() {
    await this.loadPayItemTypeHandler();
  },
};
</script>